import { ioExtend, ioGuid, QueryParams } from '@framework';

export class AuthUserModel {
    UserID = null;
    constructor(_User: {}) {
        ioExtend(this, _User);
    }
}

export class UserModel {

    ProjectID=null;
    Project=null;
    Hostname= null;
    InstanceID = null;
    Instance = null;
    InstanceTitle = null;
    UserID = null;
    Name = null;
    Username = null;
    Email = null;
    Mobile = null;
    UserGroupID = null;
    GroupName = null;
    UserRoleID = null;
    RoleName = null;
    ProfileURL = null;
    apiURL = null;
    Status = null;
    DateCreated: Date = null;
    RequireOTP = null;
    AppSettings= null;

    isNew = true;
    constructor(_User?: {}) {
        if (_User) {
            this.isNew = false;
        } else {
            this.UserID = ioGuid.New();
        }
        ioExtend(this, _User);
    }

    toJSONData() {
        return JSON.stringify(this);
    }

    toQueryParamData() {
        return QueryParams.stringify(this);
    }
}

export class UserProfileModel {

 
    UserID = null;
    Name = null;
    //Username = null;
    Email = null;
    Mobile = null;

    constructor(_Instance?: {}) {
        ioExtend(this, _Instance);
    }

    toJSONData() {
        return JSON.stringify(this);
    }

    toQueryParamData() {
        return QueryParams.stringify(this);
    }
}


export class UserRoleModel {
    UserRoleID = null;
    Name = null;
    ParentID: string = null;
    Level = null;
    Permission = {};
    SortOrder = null;
    Status = true;
    DateCreated: Date = null;

    constructor(_userRole?: {}, _userRoleID?: string) {
        ioExtend(this, _userRole);
        if (_userRoleID) { this.UserRoleID = _userRoleID; };
    }
}


export class UserGroupModel {
    UserGroupID: string = ioGuid.New();
    ParentID: string = null;
    Level = null;
    Name = null;
    SortOrder = null;
    Status = null;
    DateCreated: Date = null;

    constructor(_userGroup?: {}, _userGroupID?: string) {
        ioExtend(this, _userGroup);
        if (_userGroupID) { this.UserGroupID = _userGroupID; };
    }
}
